import audi from '../../../../static/assets/manufacturers/audi.png'
import avia from '../../../../static/assets/manufacturers/avia.png'
import babetta from '../../../../static/assets/manufacturers/babetta.png'
import bmw from '../../../../static/assets/manufacturers/bmw.png'
// noinspection JSNonASCIINames,NonAsciiCharacters
import citroën from '../../../../static/assets/manufacturers/citroën.png'
import daf from '../../../../static/assets/manufacturers/daf.png'
import fiat from '../../../../static/assets/manufacturers/fiat.png'
import ford from '../../../../static/assets/manufacturers/ford.png'
import honda from '../../../../static/assets/manufacturers/honda.png'
import iveco from '../../../../static/assets/manufacturers/iveco.png'
import jawa from '../../../../static/assets/manufacturers/jawa.png'
import kawasaki from '../../../../static/assets/manufacturers/kawasaki.png'
import man from '../../../../static/assets/manufacturers/man.png'
import opel from '../../../../static/assets/manufacturers/opel.png'
import peugeot from '../../../../static/assets/manufacturers/peugeot.png'
import renault from '../../../../static/assets/manufacturers/renault.png'
import scania from '../../../../static/assets/manufacturers/scania.png'
// noinspection JSNonASCIINames,NonAsciiCharacters
import škoda from '../../../../static/assets/manufacturers/škoda.png'
import suzuki from '../../../../static/assets/manufacturers/suzuki.png'
import tatra from '../../../../static/assets/manufacturers/tatra.png'
import volkswagen from '../../../../static/assets/manufacturers/volkswagen.png'
import yamaha from '../../../../static/assets/manufacturers/yamaha.png'

// noinspection JSNonASCIINames,NonAsciiCharacters
export default {
  audi,
  avia,
  babetta,
  bmw,
  citroën,
  daf,
  fiat,
  ford,
  honda,
  iveco,
  jawa,
  kawasaki,
  man,
  opel,
  peugeot,
  renault,
  scania,
  škoda,
  suzuki,
  tatra,
  volkswagen,
  yamaha,
}
